import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/transactionDetailsElement.svg'


const _withScopeId = n => (_pushScopeId("data-v-638e623a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transaction-details w-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "transaction-details-icon",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalSearchInput = _resolveComponent("GlobalSearchInput")!
  const _component_PageHeaderTitle = _resolveComponent("PageHeaderTitle")!
  const _component_TransactionDetailsCard = _resolveComponent("TransactionDetailsCard")!
  const _component_BANCard = _resolveComponent("BANCard")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_TransactionDetailsInputOutputTab = _resolveComponent("TransactionDetailsInputOutputTab")!
  const _component_TransactionDetailsDelegationTab = _resolveComponent("TransactionDetailsDelegationTab")!
  const _component_TransactionDetailsPoolsTab = _resolveComponent("TransactionDetailsPoolsTab")!
  const _component_TransactionDetailsStakeAddressTab = _resolveComponent("TransactionDetailsStakeAddressTab")!
  const _component_TransactionDetailsMetaDataTab = _resolveComponent("TransactionDetailsMetaDataTab")!
  const _component_TabContainer = _resolveComponent("TabContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GlobalSearchInput),
    _createVNode(_component_PageHeaderTitle, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("Transaction Details")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { class: "mb-32" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          lg: 15,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TransactionDetailsCard, {
              class: "mt-30",
              transactionDetails: _ctx.transactionDetailsForDisplay,
              loading: _ctx.isLoading
            }, null, 8, ["transactionDetails", "loading"]),
            _createVNode(_component_a_row, {
              class: "mt-32",
              justify: "center",
              align: "middle",
              wrap: "",
              gutter: { lg: 16 }
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardDetails, (item) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    lg: 12,
                    xs: 24,
                    key: item
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BANCard, {
                        class: "mb-20",
                        cardDetails: item,
                        loading: _ctx.isLoading
                      }, null, 8, ["cardDetails", "loading"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          lg: 9,
          xs: 0
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_TabContainer, {
      "tab-items": _ctx.tabItems,
      "default-active-key": "inputOutput"
    }, {
      inputOutput: _withCtx(() => [
        _createVNode(_component_TransactionDetailsInputOutputTab, {
          "transaction-details-for-display": _ctx.transactionDetailsForDisplay,
          "is-loading": _ctx.isLoading
        }, null, 8, ["transaction-details-for-display", "is-loading"])
      ]),
      delegation: _withCtx(() => [
        _createVNode(_component_TransactionDetailsDelegationTab, {
          "transaction-details-for-display": _ctx.transactionDetailsForDisplay,
          "is-loading": _ctx.isLoading
        }, null, 8, ["transaction-details-for-display", "is-loading"])
      ]),
      poolsUpdate: _withCtx(() => [
        _createVNode(_component_TransactionDetailsPoolsTab, {
          "transaction-details-for-display": _ctx.transactionDetailsForDisplay,
          "is-loading": _ctx.isLoading
        }, null, 8, ["transaction-details-for-display", "is-loading"])
      ]),
      stakeAddresses: _withCtx(() => [
        _createVNode(_component_TransactionDetailsStakeAddressTab, {
          "transaction-details-for-display": _ctx.transactionDetailsForDisplay,
          "is-loading": _ctx.isLoading
        }, null, 8, ["transaction-details-for-display", "is-loading"])
      ]),
      metaData: _withCtx(() => [
        _createVNode(_component_TransactionDetailsMetaDataTab, {
          "transaction-details-for-display": _ctx.transactionDetailsForDisplay,
          "is-loading": _ctx.isLoading
        }, null, 8, ["transaction-details-for-display", "is-loading"])
      ]),
      _: 1
    }, 8, ["tab-items"])
  ]))
}